import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type IntegrationDetailBasicDataFragment = { id: string, status: Types.IntegrationStatusEnum, connectedAt: string, scope: Types.IntegrationScopeEnum, connectedBy?: { name?: string | null, id: string, profilePicture?: string | null } | null };


export type IntegrationDetailBasicDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IntegrationDetailBasicDataFragmentDoc = /*#__PURE__*/ gql`
    fragment IntegrationDetailBasicData on IntegrationDetailType {
  id
  status
  connectedBy {
    name
    id
    profilePicture
  }
  connectedAt
  scope
}
    `;